/**
 * Copyright © 2026 Adnuntius AS.
 */
import {DefaultItemTitleRouteComponent} from './default-item-title-route.component';

export function getResourceItemTitleView() {
  return {
    component: DefaultItemTitleRouteComponent
  };
}

/** Default resolves so optional title bindings do not fail when unused. */
export function getResourceItemTitleResolves(objectTypeKey?: string, crumbParams?: any[]) {
  return {
    objectTypeKey: function() {
      return objectTypeKey || null;
    },
    titleCrumbParams: function() {
      return crumbParams || null;
    },
    titleVariant: function() {
      return null;
    },
    lineItemInfo: function() {
      return null;
    },
    folioFromParam: function() {
      return null;
    },
    advertiserFromParam: function() {
      return null;
    },
    workspace: function() {
      return null;
    },
    isNew: function($stateParams: any) {
      return $stateParams.isNew;
    }
  };
}
